<template>
  <div class="exchange-coins-page">
    <!-- 顶部导航 -->
    <van-nav-bar
      :title="$t('column.exchange_coins')"
      left-arrow
      @click-left="goBack"
    >
      <template #right>
        <span class="nav-right-btn" @click="showRules">{{ $t('column.Rules') }}</span>
      </template>
    </van-nav-bar>

    <!-- 积分信息卡片 -->
    <van-col span="22" offset="1" class="points-card">
      <van-col span="24" class="available-points">
        <span class="points-value">{{ user.useable_ticket }}</span>
        <span class="points-label">{{ $t('exchange.available_points') }}</span>
      </van-col>
      <van-row class="points-row">
        <van-col span="12" class="points-item">
          <span class="points-number">{{ user.useable_ticket }}</span>
          <span class="points-text">{{ $t('exchange.total') }}</span>
        </van-col>
        <van-col span="12" class="points-item">
          <span class="points-number">{{ user.refund_ticket }}</span>
          <span class="points-text">
            {{ $t('exchange.unconfirmed') }}
            <van-icon name="question-o" size="14" color="#999" />
          </span>
        </van-col>
      </van-row>
    </van-col>

    <!-- 兑换选项 -->
    <van-col span="22" offset="1">
      <van-row class="exchange-options" gutter="20">
          <van-col span="12" v-for="(item,i) in exchangeOptions" :key="i">
            <van-col span="24" class="option-card" :class="{ 'option-active': selectedOption === i }" @click="selectOption(i)">
                <van-col span="24" class="option-icon-row">
                <img src="../assets/img/coin10.png" class="option-icon" />
                <span class="option-value">{{ item.coin }}</span>
                </van-col>
                <van-col span="24" class="option-icon-row">
                <img src="../assets/img/coin9.png" class="option-icon" />
                <span class="option-value2">{{ item.ticket }}</span>
                </van-col>
            </van-col>
          </van-col>
          <van-col span="12" >
            <van-col span="24" class="option-card" :class="{ 'option-active': selectedOption === -1 }" @click="selectOption(-1)">
                <van-col span="24" class="option-icon-row2">
                      {{ $t('exchange.customize') }} <van-icon name="arrow" size="16" />
                </van-col>
            </van-col>
          </van-col>
        
      </van-row>
    </van-col>
    <van-col span="22" offset="1">
      <!-- 提示文本 -->
      <van-col span="24" class="exchange-tip" @click="showExchangeTipDialog">
        <van-col span="22">{{ $t('exchange.agent_account_tip') }}</van-col>
        <van-col span="2" class="exchange-tip-icon"><van-icon name="arrow" size="16" /></van-col>
      </van-col>
      
      <!-- 兑换数量卡片 -->
      <van-col span="24" class="exchange-quantity-card" v-if="selectedOption < 0">
        <van-col span="24" class="quantity-title">{{ $t('exchange.exchange_quantity') }}</van-col>
        <van-row class="quantity-calc-row" align="middle">
          <van-col span="7" class="quantity-input-wrapper">
            <van-field
              v-model="exchangeQuantity"
              type="number"
              placeholder=""
              class="quantity-input"
              @input="calculateExchange"
            />
          </van-col>
          <van-col span="17" class="quantity-coin">
            <span class="quantity-symbol">×</span>
            <img src="../assets/img/coin9.png" class="calc-icon" />
            <span class="calc-value">{{ baseCoin | formatNumber }}</span>
            <span v-if="exchangeQuantity > 0">
                <span class="quantity-symbol">=</span>
              <img src="../assets/img/coin10.png" class="calc-icon" />
              <span class="calc-value">{{ calculatedTicket | formatNumber }}</span>
            </span>
          </van-col>
          <!-- <van-col span="11" class="quantity-result">
             
          </van-col> -->
        </van-row>
      </van-col>
    </van-col>

    <!-- 验证码输入 -->
    <van-col span="22" offset="1" class="verification-section">
      <van-col span="24" class="verification-title">{{ $t('column.verification_code') }}</van-col>
      <van-row class="verification-input-row" gutter="10">
        <van-col span="17">
          <van-field
            v-model="verificationCode"
            :placeholder="$t('placeholder.enter_verification_code')"
            class="verification-input"
          />
        </van-col>
        <van-col span="7">
          <van-button 
            class="send-code-btn" 
            @click="refreshCaptchaCode"
          >
            {{ captchaCode }}
            <van-icon name="replay" :class="{ 'rotating': isRefreshing }" />
          </van-button>
        </van-col>
      </van-row>
    </van-col>

    <!-- 底部兑换按钮 -->
    <van-col span="22" offset="1" class="exchange-btn-wrapper">
      <van-button 
        color="#F45782" 
        block 
        round 
        class="exchange-btn"
        @click="handleExchange"
      >
        {{ $t('column.exchange_coins') }}
      </van-button>
    </van-col>

    <!-- 规则弹窗 -->
    <van-popup v-model="rulesShow" round :style="{ height: '60%', width: '90%' }">
      <van-col span="24" class="rules-popup">
        <van-col span="22" offset="1" class="rules-title">{{ articleList.title }}</van-col>
        <van-col span="22" offset="1" class="rules-content" v-html="articleList.content"> 
        </van-col>
      </van-col>
    </van-popup>

    <!-- 兑换说明弹框 -->
    <van-popup v-model="exchangeTipShow" position="bottom" round class="exchange-tip-dialog">
      <van-col span="24" class="exchange-tip-dialog-content">
        <van-col span="24" class="exchange-tip-dialog-header">
           <van-col span="17" offset="3" class="exchange-tip-dialog-header">
          <span class="exchange-tip-dialog-title">{{ $t('exchange.exchange_coins_title') }}</span>
        </van-col>
        <van-col span="4" class="exchange-tip-dialog-header">
          <van-icon name="cross" size="16" @click="exchangeTipShow = false" />
        </van-col>
        </van-col>
        <van-col span="24" class="exchange-tip-dialog-body">
          <van-col span="24" class="exchange-tip-question">
            {{ $t('exchange.redeemed_coins_question') }}
          </van-col>
          <van-col span="24" class="exchange-tip-answer">
            {{ $t('exchange.redeemed_coins_answer') }}
          </van-col>
          <van-col span="24" class="exchange-tip-image-wrapper">
            <img src="../assets/img/coin_exchange_image_description.png" class="exchange-tip-image" />
          </van-col>
        </van-col>
      </van-col>
    </van-popup>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import axios from 'axios'
import { Toast, Dialog } from 'vant'

export default {
  name: 'ExchangeCoins',
  data() {
    return {
      user: {
        useable_ticket: 0,
        ticket: 0,
        refund_ticket: 0,
        diamonds: 0
      },
      selectedOption: 0,
      exchangeOptions: [],
      exchangeRuleIds: [],
      exchangeQuantity: 0,
      baseCoin: 0,
      baseTicket: 0,
      verificationCode: '',
      captchaCode: '',
      rulesShow: false,
      articleList: [],
      exchangeTipShow: false,
      isRefreshing: false
    }
  },
  filters: {
    formatNumber(value) {
      if (!value) return '0'
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  computed: {
    calculatedTicket() {
      console.log('Base Ticket:', this.baseTicket)
      console.log('Exchange Quantity:', this.exchangeQuantity)
      if (!this.exchangeQuantity || this.exchangeQuantity < 0) {
        return this.baseTicket
      }
      return Math.floor(this.baseTicket * this.exchangeQuantity)
    }
  },
  created() {
    this.loadPointsData()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    showRules() {
      this.rulesShow = true
    },
    showExchangeTipDialog() {
      this.exchangeTipShow = true
    },
    calculateExchange() {
      console.log('Exchange Quantity:', this.exchangeQuantity)
      if (!this.exchangeQuantity || this.exchangeQuantity < 1) {
        this.exchangeQuantity = 0
      }else{
        this.exchangeQuantity = Math.floor(this.exchangeQuantity)
      }
    },
    loadPointsData() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + '?ctl=wallet&act=coin_seller_exchange_list', {
        params: { uid: uid, token: token }
      }).then(res => {
        if (res.data.status === 1) {
          const data = res.data.data
          this.user = data.user
          this.captchaCode = data.captcha_code
          this.baseCoin = data.seller_exchange_rate
          this.baseTicket = data.seller_exchange_income
          this.articleList = data.article_list || []
          // 将规则列表转换为兑换选项
          if (data.list && data.list.length > 0) {
            this.exchangeOptions = data.list.map(item => ({
              ticket: item.ticket,
              coin: item.coin
            }))
            this.exchangeRuleIds = data.list.map(item => item.id)
          }
        } else {
          Toast(res.data.error)
        }
      }).catch(err => {
        Toast(this.$t('exchange.load_failed'))
      })
    },
    selectOption(index) {
      this.exchangeQuantity = 0
      this.selectedOption = index
    },
    refreshCaptchaCode() {
      // 如果正在刷新中，则不重复触发
      if (this.isRefreshing) return
      
      this.isRefreshing = true
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + '?ctl=wallet&act=refresh_captcha_code', {
        params: { uid: uid, token: token }
      }).then(res => {
        if (res.data.status === 1) {
          this.captchaCode = res.data.data.captcha_code
        } else {
          Toast(res.data.error)
        }
      }).catch(err => {
        Toast(err.message)
      }).finally(() => {
        // 请求完成后停止旋转
        setTimeout(() => {
          this.isRefreshing = false
        }, 500)
      })
    },
    handleExchange() {
      if (!this.verificationCode) {
        Toast(this.$t('exchange.please_enter_code'))
        return
      }
      if (this.exchangeRuleIds.length === 0) {
        Toast(this.$t('exchange.no_exchange_rules'))
        return
      }
      
      // 显示确认框
      Dialog.confirm({
        title: this.$t('exchange.confirm_exchange'),
        message: this.$t('exchange.confirm_exchange_message')
      }).then(() => {
        // 用户点击确认
        this.doExchange()
      }).catch(() => {
        // 用户点击取消
      })
    },
    doExchange() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      const ruleId = this.selectedOption > -1 ? this.exchangeRuleIds[this.selectedOption] : 0
      const ticket = Math.floor(this.exchangeQuantity * this.baseCoin)
      axios.get(this.baseUrlApi + this.baseUrlPath + '?ctl=wallet&act=exchange_ticket_to_coin', {
        params: { uid: uid, token: token, id: ruleId, captcha_code: this.verificationCode, ticket: ticket }
      }).then(res => {
        if (res.data.status === 1) {
          Toast(res.data.error)
          // 刷新余额数据
          this.loadPointsData()
          this.exchangeQuantity = 0
          this.verificationCode = ''
        } else {
          Toast(res.data.error)
          // 验证码错误或过期时刷新验证码
          if (res.data.error === this.$t('exchange.code_expired') || res.data.error === this.$t('exchange.code_incorrect')) {
            this.refreshCaptchaCode()
          }
        }
      }).catch(err => {
        Toast(this.$t('exchange.exchange_failed'))
      })
    }
  }
}
</script>

<style scoped>
/* 刷新图标旋转动画 */
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.rotating {
  animation: rotate 1s linear infinite;
  display: inline-block;
}

.send-code-btn .van-icon {
  margin-left: 4px;
  vertical-align: middle;
}

/* 提示文本样式 */
.exchange-tip {
  background-color: #FFF3F7;
  color: #F38CAF;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 13px;
  margin-bottom: 16px;
  line-height: 1.5;
  .exchange-tip-icon{margin-top: 3vw;text-align: right;}
}

/* 兑换数量卡片 */
.exchange-quantity-card {
  background-color: #FFFFFF;
  border-radius: 16px;
  padding: 20px 16px;
  margin-bottom: 16px;
}

.quantity-title {
  font-weight: 500;
  color: #4D4E53;
  margin-bottom: 20px;
}

.quantity-calc-row {
  align-items: center;
}

.quantity-input-wrapper {
  display: flex;
  align-items: center;
}

.quantity-input {
  background-color: #F5F5F5;
  border-radius: 8px;
  text-align: center;
  padding: 0 8px;
  font-weight: 500;
  height: 9vw;
  line-height: 9vw;
}

.quantity-input >>> .van-field__control {
  text-align: center;
}

.quantity-symbol {
  color: #666;
  font-weight: 500;
}

.quantity-coin{
  text-align: left;
  height: 9vw;line-height: 9vw;
  padding-left: 2vw;
}

.calc-icon {
  height: 4vw;
  vertical-align: middle;
}

.calc-value {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

/* 兑换说明弹框样式 */
.exchange-tip-dialog {
  .exchange-tip-dialog-content {
    padding: 20px;
  }
  
  .exchange-tip-dialog-header {
    margin-bottom: 3vw;
    text-align: center;
    .exchange-tip-dialog-title {
      font-weight: 600;
      color: #1A1A1A;
    }
  }
  
  .exchange-tip-dialog-body {
    .exchange-tip-question {
      font-size: 16px;
      font-weight: 600;
      color: #1A1A1A;
      margin-bottom: 3vw;
    }
    
    .exchange-tip-answer {
      font-size: 0.8rem;
      color: #999;
      margin-bottom: 3vw;
    }
    
    .exchange-tip-image-wrapper {
      text-align: center;
      
      .exchange-tip-image {
        width: 100%;
        max-width: 100%;
        height: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coin_dealer_exchange.vue